var map = {
	"./9.png": "OdAm",
	"./9en.png": "3jfe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kjj1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi ^\.\/9.*\.png$
// module id = kjj1
// module chunks = 0